//! DO NOT EDIT THIS FILE IT IS GENERATED USING:
// mgs generate-flags

// Default On Variation: true
// Default Off Variation: false
export const FF_REFUND_NON_REFUND_CREDIT = 'refund_non_refund_credit';

// Description: As a Pharmacist, I would like to see the inventory count of products assigned to orders and Available stock in Pharmacy Access.
// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACY_STOCK_ENHANCEMENT = 'pharmacy_stock_enhancement';

// Description: Feature toggle for the new Dispense flow introduced in MC-3844 and MC-3589
// Default On Variation: true
// Default Off Variation: false
export const FF_PROCESSING_DISPENSE_FLOW = 'processing_dispense_flow';

// Description: Feature flag for Unable to dispense workflow https://montugroup.atlassian.net/browse/MC-3798
// Default On Variation: true
// Default Off Variation: false
export const FF_UNABLE_TO_DISPENSE = 'unable_to_dispense';

// Description: When this flag is on the banner will be displayed in payment page indicating that there can be intermittent payment issues.
// Default On Variation: Please note possible payment outage on April 22 between 2-5am AEST due to maintenance. Thank you for your patience.
// Default Off Variation: OFF
export const FF_SHOW_PAYMENT_WARNING = 'show_payment_warning';

// Description: This flag enables the 3 new toggles we introduce on montu admin when editing a product (Supply chain risk-Product exclusion from new
// prescriptions-generative scripting)
// Default On Variation: true
// Default Off Variation: false
export const FF_GENERATIVE_SCRIPTING_TOGGLES = 'generative_scripting_toggles';

// Default On Variation: 3
// Default Off Variation: 13.64
export const FF_SHIPPING_PRICE = 'shipping_price';

// Default On Variation: true
// Default Off Variation: false
export const FF_ORDER_FORM_DISABLE_EDIT_IF_PAID = 'order_form_disable_edit_if_paid';

// Description: Flag to enable the new endpoint that fixes a bug with discounts
// Default On Variation: true
// Default Off Variation: false
export const FF_USE_NEW_EDIT_ORDER_ENDPOINT = 'use_new_edit_order_endpoint';

// Description: Allows us to quickly disable and re-enable the booking buttons for consultations
// Default On Variation: true
// Default Off Variation: false
export const FF_DISABLE_CONSULTATION_BUTTONS = 'disable_consultation_buttons';

// Description: A flag used to toggle features used in the ERX Paper Script Solution. Also see ERX Token Generation Solution for related flags
// Default On Variation: true
// Default Off Variation: false
export const FF_ERX_PAPER_SCRIPT_SOLUTION = 'erx_paper_script_solution';

// Description: Flag to disable Product Edits in Circuit, getting ready for using Product Edits from Shopify
// https://montugroup.atlassian.net/browse/B2CS-87
// Default On Variation: true
// Default Off Variation: false
export const FF_SHOPIFY_DISABLE_PRODUCT_EDIT = 'shopify_disable_product_edit';

// Description: https://montugroup.atlassian.net/browse/B2CS-98
// Default On Variation: true
// Default Off Variation: false
export const FF_USE_SHOPIFY_PRODUCT_IMAGES = 'use_shopify_product_images';

// Description: When enabled all users are shown the maintenance screen
// Default On Variation: true
// Default Off Variation: false
export const FF_SHOW_MAINTENANCE_SCREEN = 'show_maintenance_screen';

// Description: When this flag is enabled patient will be presented with Shopify checkout page instead of Circuit bespoke checkout page
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SHOPIFY_CHECKOUT = 'enable_shopify_checkout';

// Description: when enabled allows pharmacist to filter orders on /pharmacist/orders by order status
// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACY_FILTER_ORDERS_BY_STATUS = 'pharmacy_filter_orders_by_status';

// Description: Leverage the new capability of multiple product images to show carousels on the product catalogue pages
// Default On Variation: true
// Default Off Variation: false
export const FF_PRODUCT_IMAGE_CAROUSEL = 'product_image_carousel';

// Description: Updated patient order statuses to reduce confusion. This feature flag only impacts what patients see in the patient portal, it does
// not impact the granular statuses that the Montu team sees. --> https://montugroup.atlassian.net/browse/FX-266
// Default On Variation: true
// Default Off Variation: false
export const FF_UPDATED_PATIENT_ORDER_STATUSES = 'UPDATED_PATIENT_ORDER_STATUSES';

// Description: This is to allow us to toggle the visibility of the word of mouth campaign that allows us to generate referral codes
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_WOM_CAMPAIGN = 'enable_wom_campaign';

// Description: When enabled, patients who have made orders in the past two weeks that have been shipped by pharmacies will see this component
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ORDER_TRACKING_STATUS_NOTIFICATION = 'enable_order_tracking_status_notification';

// Description: Enable super admins to adjust inventory.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SUPER_ADMIN_INVENTORY = 'enable_super_admin_inventory';

// Description: enables patient profile merges for super admins
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PATIENT_PROFILE_MERGE = 'enable_patient_profile_merge';

// Description: Toggles the visibility of the order assignment tool until ready for production use
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ORDER_ASSIGNMENT_TOOL = 'enable_order_assignment_tool';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SHOPIFY_DISCOUNTS = 'enable_shopify_discounts';

// Description: When enabled, FE uses a new BE endpoint which returns products and inventory for a pharmacy including inactive products instead of
// only active products.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PHARMACY_INVENTORY_INACTIVE_PRODUCTS = 'enable_pharmacy_inventory_inactive_products';

// Description: This feature flag enables or disables the display of a notice message on the modal. When enabled, the content of the Word of Mouth
// (WOM) popup is replaced with a notice message.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_NOTICE_ON_MODAL = 'enable_notice_on_modal';

// Description: FF to control rollout of google places autocomplete for Circuit
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_GOOGLE_PLACES_AUTOCOMPLETE = 'enable_google_places_autocomplete';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_GOOGLE_PLACES_AUTOCOMPLETE_PT_PROFILE = 'enable_google_places_autocomplete_pt_profile';

// Description: The FF will enable/disable features related to replacement orders functionality in FE.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_REPLACEMENT_ORDERS_IN_SHOPIFY = 'enable_replacement_orders_in_shopify';

// Description: A flag to toggle banner in circuit frontend.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SAFESCRIPT_OUTAGE_BANNER = 'enable_safescript_outage_banner';

// Description: This feature flag enables the client to filter out inactive pharmacies when searching through trusted partner pharmacies.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_INACTIVE_PHARMACY_FILTER = 'enable_inactive_pharmacy_filter';

// Description: Show product description and usage sections for my treatment plan
// Default On Variation: true
// Default Off Variation: false
export const FF_SHOW_PRODUCT_DESCRIPTION_AND_USAGE = 'show_product_description_and_usage';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ORDER_FILTER_BY_PHARMACY = 'enable_order_filter_by_pharmacy';

// Description: Replacing product catalog with only prescribed product information for compliance. https://montugroup.atlassian.net/browse/UMED-69
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_MY_TREATMENT_PLAN = 'enable_my_treatment_plan';

// Description: Show the patient refill banner regarding Shopify checkout
// Default On Variation: true
// Default Off Variation: false
export const FF_PATIENT_REFILL_CHECKOUT_BANNER = 'patient_refill_checkout_banner';

// Description: When enabled, admin discount creation button is hidden
// Default On Variation: true
// Default Off Variation: false
export const FF_DISABLE_ADMIN_DISCOUNT_CREATION = 'disable_admin_discount_creation';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHOPIFY_DISCOUNT_SUPER_ADMINS = 'shopify_discount_super_admins';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_404_AND_500_ERROR_PAGES = 'enable_404_and_500_error_pages';

// Description: Enables the patients orders white label images
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PATIENT_ORDERS_WHITE_LABEL_IMAGES = 'enable_patient_orders_white_label_images';

// Description: This is a feature flag for the auto complete address on the new Profile Page. It is separate to other autocomplete feature flags as it
// is using a new component being built in the design system
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_GOOGLE_PLACES_UMEDS = 'enable_google_places_umeds';

// Description: Redirect to new shopify thank you order summary.
// Default On Variation: true
// Default Off Variation: false
export const FF_SHOPIFY_REDIRECT_THANK_YOU_PAGE = 'shopify_redirect_thank_you_page';

// Description: https://montugroup.atlassian.net/browse/B2CS-1235
// Default On Variation: true
// Default Off Variation: false
export const FF_PATIENT_DISCHARGE_CIRCUIT_CHECKOUT_DISABLED_ALERT = 'patient_discharge_circuit_checkout_disabled_alert';

// Description: Enable umeds checkbox on Pharmacy details page
// Default On Variation: true
// Default Off Variation: false
export const FF_FF_ENABLE_UMEDS_CHECKBOX = 'FF_ENABLE_UMEDS_CHECKBOX';

// Description: The new umeds rebrand wants to keep montu brand as the partner for the initial phases.
// Default On Variation: true
// Default Off Variation: false
export const FF_POWERED_BY_UMEDS = 'powered_by_umeds';

// Description: patient_refill_checkout_banner text
// Default On Variation: Please note: vaporiser devices (that are not ARTG listed) and batteries are now no longer available due to a change in legislation. If impacted, book a follow-up appointment with your doctor to discuss alternatives.
// Default Off Variation: Please note: vaporiser devices (that are not ARTG listed) and batteries are now no longer available due to a change in legislation. If impacted, book a follow-up appointment with your doctor to discuss alternatives.
export const FF_PATIENT_REFILL_CHECKOUT_BANNER_TEXT = 'patient_refill_checkout_banner_text';

// Description: Browsing of product catalog by pharmacists
// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACIST_PRODUCT_CATALOG = 'pharmacist_product_catalog';

// Description: Enables the brand theme navigation for uMeds/Montu
// Default On Variation: true
// Default Off Variation: false
export const FF_BRAND_THEME_NAV = 'brand_theme_nav';

// Description: Controls the display of WOM campaign terms and conditions copy
// Default On Variation: Offer is only valid for participants who are new customers and who book their initial Alternaleaf nurse consultation by 31 January 2025.
// Default Off Variation: Offer is only valid for participants who are new customers.
export const FF_WOM_TNC_COPY = 'wom_tnc_copy';

// Description: Enables/Disables the Recommended Devices section of the Order Medication page in Circuit
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_RECOMMENDED_DEVICES = 'enable_recommended_devices';

// Description: Enables component on pharmacy settings page that allows adding shippit API key
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADD_SHIPPIT_TOKEN = 'ENABLE_ADD_SHIPPIT_TOKEN';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PATIENT_DISCOUNT_MODAL_TS_MIGRATION = 'enable-patient-discount-modal-ts-migration';

// Description: Enabling this flag will remove the logging out of users who hit a route that they shouldn't have hit. eg: admins trying to hit a
// super-admin route accidentally
// Default On Variation: true
// Default Off Variation: false
export const FF_PREVENT_LOGOUT_ON_UNAUTHED_NAVIGATION = 'prevent_logout_on_unauthed_navigation';

// Description: Enable pharmacy view typescript component
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PHARMACY_VIEW_TS_MIGRATION = 'enable_pharmacy_view_ts_migration';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ORDERS_TS_MIGRATION = 'enable_orders_ts_migration';

// Description: Enabling Pharmacy Report Component for TS migration
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PHARMACY_REPORT_TS_COMPONENT = 'enable_pharmacy_report_ts_component';

// Description: Enables the use of the BroadcastChannel API for local SessionStorage synchronisation.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_BROADCAST_CHANNEL_API = 'enable-broadcast-channel-api';

// Description: https://montugroup.atlassian.net/browse/UMED-858
// Default On Variation: true
// Default Off Variation: false
export const FF_ONLY_ALLOW_FULL_ORDER_ORDER_DISCOUNTS_FOR_ADMIN_ORDERS =
  'only-allow-full-order-order-discounts-for-admin-orders';

// Description: Limit the pagination size of the pharmacists order table to lte 50
// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACIST_ORDERS_TABLE_SMALL_SIZE = 'pharmacist_orders_table_small_size';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_DOCTORS_TS_MIGRATION = 'enable_doctors_ts_migration';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ORDER_ALLOCATION_TOOL_V2 = 'enable-order-allocation-tool-v2';

// Description: Updates the req body to match the createPharmacy in typescript
// Default On Variation: true
// Default Off Variation: false
export const FF_CREATE_PHARMACY_TYPESCRIPT = 'create_pharmacy_typescript';

// Description: Enable to display concession discount banner/alert on profile and order pages
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CONCESSION_DISCOUNT_BANNER = 'enable_concession_discount_banner';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PATIENT_PROFILE_UPLIFT = 'enable_patient_profile_uplift';

// Description: Align the order summary component between checkout pages
// Default On Variation: true
// Default Off Variation: false
export const FF_ALIGN_PHARMACY_ORDER_SUMMARY = 'align-pharmacy-order-summary';

// Description: enable to display the concession awareness related text and discounts on the checkout
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CONCESSION_AWARENESS_CHECKOUT = 'enable_concession_awareness_checkout';

// Description: This prevents a flash of an authenticated screen if we are about to log the user out anyway
// Default On Variation: true
// Default Off Variation: false
export const FF_AUTO_LOGOUT_ON_EXPIRED_TOKEN_REQUEST = 'auto-logout-on-expired-token-request';

// Description: Enables pharmacists/admins to view batch dispensed orders
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_BATCH_DISPENSE_VIEW = 'enable_batch_dispense_view';

// Description: if ON, redirects user to appropriate portal even if they aren't signed in. Directs to same path on the portal that they were trying to
// access on circuit.
// Default On Variation: true
// Default Off Variation: false
export const FF_DSPLIT_REDIRECT_ALL = 'dsplit_redirect_all';

// Description: Enable patient list as per new design
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PATIENT_LIST = 'enable_patient_list';

// Description: Disable Export and Ship all button in order list
// Default On Variation: true
// Default Off Variation: false
export const FF_ORDER_LIST_DISABLE_EXPORT_AND_SHIP_BUTTON = 'order_list_disable_export_and_ship_button';

// Default On Variation: true
// Default Off Variation: false
export const FF_ORDER = 'order';

// Description: Disable Export button from order list
// Default On Variation: true
// Default Off Variation: false
export const FF_ORDER_LIST_DISABLE_EXPORT_BUTTON = 'order_list_disable_export_button';

// Description: Add checkbox behind FF
// Default On Variation: true
// Default Off Variation: false
export const FF_ORDER_LIST_DISABLE_CHECKBOX = 'order_list_disable_checkbox';

// Description: Enables the eScript Order Medication and eScript Pharmacy Allocation pages
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ESCRIPT_ORDERS = 'enable_escript_orders';

// Description: Allow navigating between customer & patient portals to pass auth state and not require a re-login
// Default On Variation: true
// Default Off Variation: false
export const FF_CUSTOMER_PATIENT_PORTALS_AUTH_TRANSFER_NAVIGATIONS =
  'customer-patient-portals-auth-transfer-navigations';

// Description: enables the Pharmacy portal redirection banner if a date exists, also uses the given date in the banner text
// Default On Variation: 20/02/2025
// Default Off Variation:
export const FF_PHARMACY_PORTAL_REDIRECT_BANNER_DATE = 'pharmacy_portal_redirect_banner_date';

// Default On Variation: true
// Default Off Variation: false
export const FF_DISABLED_ORDER_DISCOUNT_BUTTON = 'disabled_order_discount_button';

// Description: When enabled, Circuit frontend will redirect patient to tasmanian doctor followup if they have a tasmanian address
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_TASMANIAN_DOCTOR_FOLLOW_UP = 'enable_tasmanian_doctor_follow_up';

// Description: Enables clickstream tracking for Checkboxes via the DesignSystem
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CHECKBOX_CLICKSTREAM = 'enable_checkbox_clickstream';

// Default On Variation: false
// Default Off Variation: false
export const FF_ENABLE_NEW_USER_AGREEMENTS_ENDPOINT = 'enable-new-user-agreements-endpoint';

// Default On Variation: true
// Default Off Variation: false
export const FF_DISABLE_PRODUCT_SELECTIONS_ON_DOCTOR_PROFILE = 'disable_product_selections_on_doctor_profile';

// Default On Variation: true
// Default Off Variation: false
export const FF_DISABLE_EDIT_ACCESS_ON_GP_PROFILE_PAGE = 'disable_edit_access_on_gp_profile_page';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PHARMACY_ORDER_PAYMENT_RECEIPTS = 'enable_pharmacy_order_payment_receipts';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_BULK_ACTIONS_REWORK = 'enable_bulk_actions_rework';

// Description: Enables the admin portal external doctor profile page
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADMIN_EXTERNAL_DOCTOR_PROFILE = 'enable_admin_external_doctor_profile';

// Description: Enables the admin product match review screen
// Default On Variation: false
// Default Off Variation: false
export const FF_ENABLE_ADMIN_PRODUCT_MATCH_REVIEW = 'enable-admin-product-match-review';

// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACIST_ORDER_LISTS_DATE_RANGE_FILTER = 'pharmacist_order_lists_date_range_filter';

// Default On Variation: 0
// Default Off Variation: 50
export const FF_DATADOG_SESSION_REPLAY_SAMPLE_RATE = 'datadog_session_replay_sample_rate';

// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_ORDER_DISABLE_INVENTORY_CHECK = 'admin_order_disable_inventory_check';

// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACY_EOM_REPORT_PAGE_UPLIFT = 'pharmacy_eom_report_page_uplift';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PHARMACY_ORDER_PAYMENT_RECEIPTS_BULK_DOWNLOAD =
  'enable_pharmacy_order_payment_receipts_bulk_download';

// Description: Pharmacy Onboarding Page Uplift
// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACY_ONBOARDING_PAGE_UPLIFT = 'pharmacy_onboarding_page_uplift';

// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_PRODUCT_CATALOG_UPDATE = 'admin_product_catalog_update';

// Description: Enable/disable the Admin Portal Interval Delay calendar feature.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADMIN_INTERVAL_CALENDAR = 'enable_admin_interval_calendar';

// Default On Variation: true
// Default Off Variation: false
export const FF_ALLOW_ACCESS_PHARMACY_FINANCE_EOM_STATEMENTS = 'allow_access_pharmacy_finance_eom_statements';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_NEW_GP_PROFILE_PAGE = 'enable_new_gp_profile_page';

// Default On Variation: true
// Default Off Variation: false
export const FF_USE_GOOGLE_OAUTH_FEDCM = 'use_google_oauth_fedcm';

// Description: Pharmacy onboarding uplift
// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACY_ADMIN_ONBOARDING_UPLIFT = 'pharmacy_admin_onboarding_uplift';

// Default On Variation: true
// Default Off Variation: false
export const FF_ESCRIPT_NEW_PAYMENT_SUCCESS_PAGE = 'escript_new_payment_success_page';

// Description: Enables Cura in the uMeds customer portal
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_UMEDS_CHATBOT = 'enable_umeds_chatbot';

// Description: Finance Self Serve page access flag, for use during development and pre-permission setup access control
// Default On Variation: true
// Default Off Variation: false
export const FF_FINANCE_SELF_SERVE = 'finance_self_serve';

// Default On Variation: true
// Default Off Variation: false
export const FF_FINANCE_SELF_SERVE_PHASE_2 = 'finance_self_serve_phase_2';

// Description: when toggled on it will show an "external" or "alternaleaf" chip on the orders in the order table and on the order details page in
// admin portal
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ORDER_TYPE_CHIPS = 'enable_order_type_chips';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PROCESSING_DISPENSE_NOTE = 'enable_processing_dispense_note';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_DISPENSING_LIMIT_COLUMNS = 'enable_dispensing_limit_columns';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_DISPENSING_LIMIT_COLUMNS_CHANGES = 'enable_dispensing_limit_columns_changes';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PROCESSING_DISPENSE_SELECTION = 'enable_processing_dispense_selection';

// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_PATIENT_PAGE_MEDICATION_TABLE_PRODUCT_STATUS =
  'admin_patient_page_medication_table_product_status';

// Default On Variation: true
// Default Off Variation: false
export const FF_FINANCE_SELF_SERVE_REFACTOR_PAGINATION = 'finance_self_serve_refactor_pagination';

// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACIST_CONFIRM_DISPENSE_MODAL_V2 = 'pharmacist_confirm_dispense_modal_v2';

// Description: Controls whether the isExternal field is included in the JWT token
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_EXTERNAL_IN_TOKEN = 'enable_external_in_token';

// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_PATIENT_PAGE_ORDER_HISTORY_LOG_DIALOG = 'admin_patient_page_order_history_log_dialog';

// Description: Enables Cura for eScripting pages in the customer portal
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ESCRIPT_CHATBOT = 'enable_escript_chatbot';

// Description: Controls with Payment options to show on the Patient Portal home page.
// Default On Variation: {"enabled":true,"extraIds":[]}
// Default Off Variation: {"enabled":false,"extraIds":[]}
export const FF_SHOW_PAYMENT_OPTIONS = 'show_payment_options';

// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACY_ALLOCATION_SETTINGS_CAN_DISPENSE_IPIP_ORDERS_TOGGLE =
  'pharmacy-allocation-settings-can-dispense-ipip-orders-toggle';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SHIPPING_OPTIONS = 'enable_shipping_options';

// Description: this flag when enabled will use order/delivery-options instead of order/allocate
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_DELIVERY_OPTIONS_ENDPOINT_FOR_PHARMACY_ALLOCATION =
  'enable-delivery-options-endpoint-for-pharmacy-allocation';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PERMISSION_BOUNDARY = 'enable_permission_boundary';

// Description: uses the new simplified order medication code for escript
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_NEW_ESCRIPT_ORDER_MEDICATION = 'enable_new_escript_order_medication';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_BEGIN_ESCRIPT_SIGNUP = 'enable_begin_escript_signup';

// Default On Variation: true
// Default Off Variation: false
export const FF_BRAZE_CONTENT_CARDS = 'braze-content-cards';

// Description: https://montugroup.atlassian.net/browse/B2C-9614
// Default On Variation: true
// Default Off Variation: false
export const FF_HIDE_ORDER_BUTTONS = 'hide_order_buttons';

// Description: https://montugroup.atlassian.net/wiki/spaces/Eng/pages/957743166/SPIKE+Variable+Consult+Types+Calcom+Decouple
// Default On Variation: true
// Default Off Variation: false
export const FF_VARIABLE_CONSULT_TYPES_ENABLED = 'variable_consult_types_enabled';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_SDD_NEXT_DAY_ENABLED = 'shipping_options_sdd_next_day_enabled';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_ADMIN_ORDER_PAGE_ALLOCATION_DETAILS =
  'shipping_options_admin_order_page_allocation_details';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ALF_IN_PATIENT_PORTAL = 'enable-alf-in-patient-portal';

// Description: Enables access to shipments via the pharmacist portal
// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACIST_ENABLE_SHIPMENTS = 'pharmacist_enable_shipments';

// Default On Variation: 2025-12-10
// Default Off Variation:
export const FF_SHIPPING_OPTIONS_CUSTOMER_ORDER_HISTORY_REMOVE_ALLOCATED_PHARMACY_AFTER_DATE =
  'shipping_options_customer_order_history_remove_allocated_pharmacy_after_date';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_CUSTOMER_ORDER_HISTORY_ENABLE_VALID_ID_ALERT =
  'shipping_options_customer_order_history_enable_valid_id_alert';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_CUSTOMER_PROCESS_CHECKOUT_PASS_DELIVERY_OPTION =
  'shipping_options_customer_process_checkout_pass_delivery_option';

// Default On Variation: true
// Default Off Variation: false
export const FF_ESCRIPT_RECONCILE_PRESCRIPTIONS = 'escript_reconcile_prescriptions';

// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_PORTAL_UMEDS_THEME = 'admin_portal_umeds_theme';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_CUSTOMER_PROCESS_CHECKOUT_USE_NEW_SHIPPING_OPTIONS_ENDPOINT =
  'shipping_options_customer_process_checkout_use_new_shipping_options_endpoint';

// Description: Close calcom iFrames on successful bookings to prevent navigation rebooking issues
// Default On Variation: true
// Default Off Variation: false
export const FF_CLOSE_CALCOM_IFRAME_ON_SUCCESS = 'close_calcom_iframe_on_success';

// Description: Enables pharmacy referrals feature
// Default On Variation: true
// Default Off Variation: false
export const FF_PHARMACY_REFERRALS = 'pharmacy_referrals';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PHARMACY_PORTAL_SHIPPING_OPTIONS = 'enable_pharmacy_portal_shipping_options';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_ALLOW_DISPLAY_OF_SAME_DAY_OPTION = 'shipping_options_allow_display_of_same_day_option';

// Description: enables new user roles and permissions pages in admin-portal
// Default On Variation: true
// Default Off Variation: false
export const FF_ADMIN_USER_ROLES_AND_PERMISSIONS_PAGES = 'admin_user_roles_and_permissions_pages';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_ADMIN_PHARMACY_PAGE_SHIPPING_OPTIONS_FORM =
  'shipping_options_admin_pharmacy_page_shipping_options_form';

// Description: https://montugroup.atlassian.net/browse/UMED-6656
// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_ADMIN_ORDERS_REMOVE_CONSIGNMENT_ID_AND_UPDATE_TRACKING_ID_LOGIC =
  'shipping_options_admin_orders_remove_consignment_id_and_update_tracking_id_logic';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PHARMACY_SIGN_IN_REWRITE = 'enable_pharmacy_sign_in_rewrite';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_MFA_SETUP = 'enable_mfa_setup';

// Description: https://montugroup.atlassian.net/browse/UMED-7651 experimenting with swapping the umeds card on patient portal homepage
// Default On Variation: true
// Default Off Variation: false
export const FF_EXPERIMENT_SWAPPING_UMEDS_CARD_ON_HOMEPAGE = 'experiment_swapping_umeds_card_on_homepage';

// Description: Enable MFA settings on Patient Profile page in Admin Portal
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADMINPORTAL_PATIENT_MFA = 'enable_adminportal_patient_mfa';

// Description: https://montugroup.atlassian.net/browse/LGA-68
// Default On Variation: true
// Default Off Variation: false
export const FF_REMOVE_SIGNATURE_BOX_FROM_CONSENT_FORM = 'remove_signature_box_from_consent_form';

// Description: percentage of sessions capturing RUM, AND session replays
// Default On Variation: 100
// Default Off Variation: 50
export const FF_DATADOG_SESSION_SAMPLE_REPLAY_RATE = 'datadog-session-sample-replay-rate';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PATIENT_PORTAL_PHONE_UPDATE_VERIFICATION = 'enable_patient_portal_phone_update_verification';

// Description: Controls visibility of the “Download Treatment Letter” link in the Patient Portal Prescriptions view. When ON, the link displays; when
// OFF, it is hidden.
// Default On Variation: true
// Default Off Variation: false
export const FF_DOWNLOAD_TREATMENT_LETTER = 'download-treatment-letter';

// Default On Variation: true
// Default Off Variation: false
export const FF_DO_NOT_CHECK_INVENTORY_FOR_OOS_STATUS = 'do_not_check_inventory_for_oos_status';

// Description: https://montugroup.atlassian.net/browse/LGA-329
// Default On Variation: true
// Default Off Variation: false
export const FF_DOCTORS_ROUND_ROBIN_FOR_UNDER_25 = 'doctors_round_robin_for_under_25';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ALLOCATION_LIMIT = 'enable_allocation_limit';

// Description: To allow testing with the various tokens for various scenarios
// Default On Variation: true
// Default Off Variation: false
export const FF_PPP_TESTING = 'ppp_testing';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CANCEL_UNPAID_ADMIN_ORDER_ON_REFILL = 'enable_cancel_unpaid_admin_order_on_refill';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADMIN_PORTAL_CANCEL_UNPAID_ADMIN_ORDER_ON_REFILL =
  'enable_admin_portal_cancel_unpaid_admin_order_on_refill';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CLICK_COLLECT_SHIPPING_OPTION = 'enable_click_collect_shipping_option';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADMIN_PORTAL_DISCOUNT_LIST_ACTION_MODALS = 'enable_admin_portal_discount_list_action_modals';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_ALLOW_DISPLAY_OF_SAME_DAY_AFTERNOON_OPTION =
  'shipping_options_allow_display_of_same_day_afternoon_option';

// Default On Variation: true
// Default Off Variation: false
export const FF_SHIPPING_OPTIONS_SAME_DAY_AFTERNOON_NEXT_DAY_ENABLED =
  'shipping_options_same_day_afternoon_next_day_enabled';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADMIN_PORTAL_EDIT_OR_OVERRIDE_EXISTING_DISCOUNT_MODAL =
  'enable_admin_portal_edit_or_override_existing_discount_modal';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_NEW_CHECKOUT_ENDPOINT = 'enable_new_checkout_endpoint';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CIRCUIT_ONLY_DISCOUNTS = 'enable_circuit_only_discounts';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADMIN_PATIENT_PAGE_DISCOUNT_TABLE_IMPROVEMENTS =
  'enable_admin_patient_page_discount_table_improvements';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CUSTOMER_SHIPPING_OPTION_DISCOUNTS = 'enable_customer_shipping_option_discounts';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CUSTOMER_DISCOUNTS_SHOW_REMAINING_COST = 'enable_customer_discounts_show_remaining_cost';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PHARMACY_CLICK_AND_COLLECT_UI = 'enable_pharmacy_click_and_collect_ui';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_THANK_YOU_PAGE = 'enable_thank_you_page';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_SHIPPING_ALLOW_CUTOFF_OR_VALID_BEFORE_IN_PAST =
  'enable_shipping_allow_cutoff_or_valid_before_in_past';

// Default On Variation: true
// Default Off Variation: false
export const FF_USER_ENABLE_ACCOUNT_DEACTIVATION = 'user_enable_account_deactivation';

// Description: Enables the View Receipt button on the order page to lazily request the receipt PDF.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_LAZY_ORDER_RECEIPT = 'enable_lazy_order_receipt';

// Default On Variation: true
// Default Off Variation: false
export const FF_AUTH_ENABLE_SESSION_STORAGE = 'auth_enable_session_storage';

// Default On Variation: true
// Default Off Variation: false
export const FF_ESCRIPT_ENABLE_PRESCRIPTIONS_PAGES = 'escript_enable_prescriptions_pages';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_WA_DOCTOR_FOLLOW_UP = 'enable_wa_doctor_follow_up';

// Default On Variation: true
// Default Off Variation: false
export const FF_AUTH_ENABLE_CROSS_TAB_SESSION_SYNC = 'auth_enable_cross_tab_session_sync';

// Default On Variation: true
// Default Off Variation: false
export const FF_AUTH_ENABLE_SESSION_HEARTBEAT = 'auth_enable_session_heartbeat';

// Description: Enables the rebuild Invoices page
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADMIN_INVOICES_REFACTOR = 'enable_admin_invoices_refactor';

// Description: Set the createdBy field on the calcom button when booking consultations
// Default On Variation: true
// Default Off Variation: false
export const FF_CALCOM_SET_CREATEDBY = 'calcom_set_createdby';

// Description: flag to toggle for when erx is disabled and manual validation is needed
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ERX_FALLBACK = 'enable_erx_fallback';

// Description: Enables the Interval Timeline in the UTD Modal
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_UTD_MODAL_TIMELINE = 'enable_utd_modal_timeline';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ESCRIPT_PRESCRIPTION_PAGE = 'enable_escript_prescription_page';

// Description: A flag to toggle between the legacy update pharmacy endpoint for activate and deactivating a pharmacy and the new endpoints.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_NEW_ACTIVATE_DEACTIVATE_PHARMACY_ENDPOINTS = 'enable-new-activate-deactivate-pharmacy-endpoints';

// Description: When uploading scripts, display returned ERX status in UI.
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ERX_STATUS_DISPLAY = 'enable_erx_status_display';

// Description: https://montugroup.atlassian.net/browse/PD-1896
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_CLICK_AND_COLLECT_PARTIAL_STOCK_WARNINGS = 'enable-click-and-collect-partial-stock-warnings';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_ADMIN_FILTER_ORDERS_BY_DELIVERY_OPTION = 'enable-admin-filter-orders-by-delivery-option';

// Description: recommended devices experiment variants
// Default On Variation: variation a
// Default Off Variation: control
export const FF_ENABLE_CHECKOUT_RECOMMENDED_DEVICES = 'enable_checkout_recommended_devices';

// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_PRODUCT_DETAIL_PAGE_REAL_DEVICE_IMAGES = 'enable_product_detail_page_real_device_images';

// Description: https://montugroup.atlassian.net/browse/PD-1285
// Default On Variation: true
// Default Off Variation: false
export const FF_ENABLE_BLOCKING_EXTERNAL_TERRITORIES = 'enable_blocking_external_territories';

// Description: Share the Care pricing shown in the patient portal. discount is the base discount and consultPrice the usual initial consultation
// price; the price shown is consultPrice minus discount, never below $0. overrides replace the base discount for a time window: each needs discount,
// startDate and endDate as ISO dates with a timezone offset (e.g. +11:00). The window includes startDate and excludes endDate, and the first matching
// override wins. An override with a missing or invalid date, an endDate not after startDate, or an invalid discount is ignored. copyVariant is
// "standard" (limited-time copy) or "increased" ("We've increased the discount" copy, only shown when the override discount is above the base).
// Always set it; if missing or unknown it falls back to "standard" and the override still applies. Display only: it changes the portal copy, not the
// discount applied to the code or the consult.
// Default On Variation: {"consultPrice":29,"discount":20,"overrides":[{"copyVariant":"standard","discount":29,"endDate":"2027-01-17T00:00:00+11:00","startDate":"2026-11-09T00:00:00+11:00"}]}
// Default Off Variation: {"consultPrice":29,"discount":20,"overrides":[]}
export const FF_WOM_PRICING = 'wom_pricing';
